export default __webpack_public_path__ + "static/media/camera.ea74d036.svg";